// Firebase Configuration
// This file centralizes Firebase initialization for use across the app

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBa13Iw9rNMYM6MT5TyizT3Q_KAFeuVH8E",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "pharmwealth-app.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "pharmwealth-app",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "pharmwealth-app.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "810215562718",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:810215562718:web:46618695792458e8a5114f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);

export default app;

